import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import libasLogo from "assets/images/libaas.png";
import mamayaLogo from "assets/images/mamayaLogo.png";
import talabgaonLogo from "assets/images/talabgaonLogo.jpg";
import chelmsford from "assets/images/chelmsford.png";
import experion from "assets/images/experion.jpg";
import hdfc_securities from "assets/images/hdfc_securities.jpg";
import the_vensej from "assets/images/the_vensej.png";
import vertigo from "assets/images/vertigo.jpeg";

function Information() {
  const partners = [
    { src: libasLogo, alt: "Libas" },
    { src: mamayaLogo, alt: "Mamaya" },
    { src: talabgaonLogo, alt: "Talabgaon" },
    { src: chelmsford, alt: "Chelmsford" },
    { src: experion, alt: "Experion" },
    { src: hdfc_securities, alt: "HDFC Securities" },
    { src: the_vensej, alt: "The Vensej" },
    { src: vertigo, alt: "Vertigo" },

    // Add more partners…
  ];

  const settings = {
    infinite: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Trusted by</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            India’s top event professionals
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Event planners, agencies, startups, and production houses count on
            us for reliable artists, transparent bookings, and premium service.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Aarav M., Delhi"
              date="1 day ago"
              review="Booking a singer took barely a few minutes. The whole process was smooth, transparent, and super easy to navigate."
              rating={4}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name="Shruti P., NCR"
              date="1 week ago"
              review="Booked a magician last minute and everything went perfectly. The platform is reliable, fast, and incredibly convenient."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Karan S., Mumbai"
              date="3 weeks ago"
              review="As an event planner, I love how seamless MakeMyShows makes artist booking. Quality performers, no delays, and zero hassle."
              rating={4.5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center", mb: 8 }}
        >
          <MKTypography variant="h2">Our Recent Collaboration</MKTypography>

          <MKTypography variant="body1" color="text" mb={2}>
            Crafting premium entertainment experiences with top-tier partners.
          </MKTypography>
        </Grid>

        {/* <Grid
          container
          spacing={12}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8} md={4} lg={2}>
            <MKBox
              component="img"
              src={libasLogo}
              alt="Apple"
              width="100%"
              opacity={0.6}
            />
          </Grid>
          <Grid item xs={8} md={4} lg={2}>
            <MKBox
              component="img"
              src={mamayaLogo}
              alt="Facebook"
              width="100%"
              opacity={0.6}
            />
          </Grid>
          <Grid item xs={8} md={4} lg={2}>
            <MKBox
              component="img"
              src={talabgaonLogo}
              alt="Nasa"
              width="100%"
              opacity={0.6}
            />
          </Grid>
        </Grid> */}
        <Slider {...settings}>
          {partners.map((logo, i) => (
            <MKBox
              key={i}
              display="flex !important"
              justifyContent="center"
              alignItems="center"
              sx={{
                width: "100px",
                height: "140px",
                padding: "10px",
              }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                style={{
                  maxWidth: "100%",
                  maxHeight: "120px",
                  objectFit: "contain",
                  // filter: "grayscale(100%)", // optional (clean look)
                  // opacity: 0.7,
                }}
              />
            </MKBox>
          ))}
        </Slider>
      </Container>
    </MKBox>
  );
}

export default Information;
